import { inject, Injectable } from '@angular/core';
import { SupabaseService } from '../../services/supabase.service';
import { firstValueFrom } from 'rxjs';
import { EntryRepository } from '../entry/entry.repository';
import { SupaStatisticsRepository } from './supa-statistics.repository';
import { todayWithTolerance } from '../day/today-with-tolerance';
import { JournalingMonthlyStreak, JournalingStreak } from './journaling-streak';
import dayjs from 'dayjs';
import { dateFormat } from '../../tools/date';

@Injectable({ providedIn: 'root' })
export class SupaStatisticsApi {
  private sb = inject(SupabaseService).client;
  private statisticsRepository = inject(SupaStatisticsRepository);
  private entryRepository = inject(EntryRepository);

  async fetchStreaks() {
    const currentStreak = await firstValueFrom(
      this.statisticsRepository.currentStreak$,
    );
    if (!currentStreak.todayIncluded) {
      const yesterdayDayWithTolerance = dayjs(todayWithTolerance())
        .subtract(1, 'day')
        .format(dateFormat);

      let { data, error } = await this.sb
        .from('streaks_view')
        .select()
        .or(`days_count.gte.2,start_at.gte.${yesterdayDayWithTolerance}`)
        .returns<JournalingStreak[]>();

      if (error) {
        console.log(error);
      }

      if (data) {
        this.statisticsRepository.setStreaks(data);
      }
    }
  }

  async fetchMonthlyStreaks() {
    let { data, error } = await this.sb
      .from('streaks_monthly_view')
      .select()
      //.or(`days_count.gte.2,start_at.gte.${yesterdayDayWithTolerance}`)
      .returns<JournalingMonthlyStreak[]>();

    if (error) {
      console.log(error);
    }

    if (data) {
      this.statisticsRepository.setMonthlyStreaks(data);
    }
  }

  async dayStats(startAt: string, endAt: string) {
    const { data, error } = await this.sb.rpc('get_day_stats', {
      params_start_at: startAt,
      params_end_at: endAt,
    });

    if (!data) {
      return [];
    }

    return data;
  }
}
